import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { Helmet } from 'react-helmet-async';
import API from '../config';
import OTPVerify from '../components/OTPVerify';

export default function VerifyEmail() {
  const { token, user, login, logout } = useAuth();
  const { T } = useTheme();
  const navigate = useNavigate();

  const handleVerified = async (code) => {
    try {
      const res = await axios.post(`${API}/api/auth/verify-otp`, { otp: code }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      login(res.data.user, res.data.token);
      navigate('/dashboard');
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Verification failed');
    }
  };

  const handleResend = async () => {
    try {
      await axios.post(`${API}/api/auth/resend-otp`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to resend' };
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans', 'Segoe UI', sans-serif", color: T.text }}>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500;700&display=swap');
        * { box-sizing:border-box; margin:0; padding:0; }
        input:focus { border-color:${T.accent} !important; outline:none; }
        @keyframes fadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
      `}</style>

      <nav style={{ height: 56, display: 'flex', alignItems: 'center', padding: '0 24px', borderBottom: `1px solid ${T.border}` }}>
        <svg width="140" height="38" viewBox="0 0 160 38" fill="none">
          <rect x="1" y="1" width="36" height="36" rx="9" fill="#131416" stroke="#2a2b2f" strokeWidth="1.5"/>
          <line x1="11" y1="30" x2="20" y2="8" stroke="#3772ff" strokeWidth="3" strokeLinecap="round"/>
          <line x1="19" y1="30" x2="28" y2="8" stroke="#16c784" strokeWidth="3" strokeLinecap="round"/>
          <text x="46" y="20" dominantBaseline="middle" fontFamily="'DM Sans',sans-serif" fontWeight="800" fontSize="18" fill={T.text} letterSpacing="-1">Mino Markets</text>
        </svg>
        <button onClick={handleLogout}
          style={{ marginLeft: 'auto', background: 'none', border: 'none', color: T.textMuted, fontSize: 13, cursor: 'pointer' }}>
          Sign out
        </button>
      </nav>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 16px', animation: 'fadeIn 0.3s ease' }}>
        <OTPVerify
          email={user?.email}
          onDone={handleVerified}
          onResend={handleResend}
          T={T}
        />
      </div>
    </div>
  );
}